import { formatString } from '@aibees/shared/utils';
import { FieldValues } from 'react-hook-form';
import { SearchFilter } from '../../../types';
import { convertValueToArray } from '../utils';

export function useBulkFilterItemState(
  field: string,
  metadata: SearchFilter['metadata'],
  value: FieldValues
) {
  const valueArray = convertValueToArray(value[field!]);
  const count = valueArray?.length ?? 0;
  const limit = metadata?.limit?.max?.size;
  const error = metadata?.limit?.max ? count > metadata.limit.max.size : false;
  const message = metadata?.limit?.max?.message
    ? formatString(
        metadata?.limit?.max?.message,
        metadata?.limit?.max?.size.toString(),
        count.toString()
      )
    : undefined;
  return { count, limit, error, message };
}
